<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <defs><style>.cls-1{display:none;}</style></defs>
  <g id="transparent_box"><rect class="cls-1" width="32" height="32"/></g>
  <g id="FILLED" fill="#F49500">
    <circle cx="15.96" cy="15.99" r="8"/>
    <rect x="14.98" y="0.99" width="2" height="4" transform="translate(-0.03 0.14) rotate(-0.5)"/>
    <rect x="5.79" y="4.81" width="2" height="4" transform="translate(-2.83 6.88) rotate(-45.51)"/>
    <rect x="1" y="15.01" width="4" height="2" transform="translate(-0.14 0.03) rotate(-0.5)"/>
    <rect x="4.82" y="24.2" width="4" height="2" transform="translate(-15.93 12.4) rotate(-45.5)"/>
    <rect x="15.02" y="26.99" width="2" height="4" transform="translate(-0.25 0.14) rotate(-0.5)"/>
    <rect x="24.2" y="23.17" width="2" height="4" transform="translate(-10.42 25.51) rotate(-45.51)"/>
    <rect x="27" y="14.97" width="4" height="2" transform="translate(-0.14 0.26) rotate(-0.5)"/>
    <rect x="23.18" y="5.79" width="4" height="2" transform="translate(2.69 19.99) rotate(-45.5)"/>
  </g>
</svg>
